import { atom } from 'jotai';

import { MIN_CHUNK_LIVE_FW, isFwAtLeast, parseFwNumericComponents } from './chunk-live';
import { chronicleDeviceStateAtom } from './connection';

/** Which pipeline feeds `chronicle:audio_rms`: 4.x MP3-byte stream RMS, or the FW 5.0 `MCU&LVL` linear-PCM-peak replay. */
export type ChronicleAmplitudeSource = 'streamRms' | 'levelMeter';

/**
 * Mirrors `MIN_CHUNK_LIVE_FW`; the cross-language pin in the test keeps them
 * equal. Aliased from `./chunk-live` so the threshold and its parser have one
 * FE definition rather than one per consumer.
 */
export const MIN_LEVEL_METER_FW = MIN_CHUNK_LIVE_FW;

// Projects the Rust selector's rule (remote_chunk_sync::capability, same
// firmwareVersion input) because no runtime source signal reaches the FE; the
// divergence cases (unresolved version, LVL probe refused) emit no frames, so
// both profiles render identically flat there.
export const chronicleAmplitudeSourceAtom = atom<ChronicleAmplitudeSource>((get) => {
  const firmwareVersion = get(chronicleDeviceStateAtom).firmwareVersion;
  const components =
    firmwareVersion === null ? null : parseFwNumericComponents(firmwareVersion);
  return components !== null && isFwAtLeast(components, MIN_LEVEL_METER_FW)
    ? 'levelMeter'
    : 'streamRms';
});
